'use client';

import React from 'react';
import { useGlobalClientContext } from '../common/GlobalClientContext';
import { workloadDescTitleClassName, workloadDescClassName } from './Styles';
import RedirectButton from './RedirectButton';

export default function DataSyncPricing() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  return (
    <>
      <div className="flex flex-col gap-3xl items-center">
        <span className={workloadDescTitleClassName}>
          {t('public.site.pricing.workload.datasync.title', {})}
        </span>
        <div className="flex flex-col items-center">
          <span className={workloadDescClassName}>
            {t('public.site.pricing.workload.datasync.desc', {})}
          </span>
        </div>
      </div>
      <RedirectButton
        className="mt-3xl"
        label={t('public.site.contact.us', {})}
      />
      <div className="flex flex-col w-full mt-9xl items-center">
        <div className="flex flex-col items-start p-7xl bg-white border border-gray-200 rounded-md shadow-lg w-[630px]">
          <div className="flex flex-col gap-3xl items-start w-full">
            <div className="flex flex-col gap-2xs items-start w-full">
              <span className="font-semibold text-5xl leading-18xl text-gray-900 whitespace-nowrap">
                {t('public.site.pricing.datasync.card.title', {})}
              </span>
              <div className="flex flex-col gap-4xs items-start text-brand-500 w-full whitespace-nowrap">
                <div className="flex gap-4xs items-end w-full text-cic-blue-500">
                  <span className="font-semibold text-2xl leading-4xl">$0.01</span>
                  <span className="font-medium text-xl leading-3xl">
                    {t('public.site.pricing.datasync.unit.gb', {})}
                  </span>
                </div>
                <div className="flex gap-4xs items-end w-full text-cic-blue-500">
                  <span className="font-semibold text-2xl leading-4xl">$0.0035</span>
                  <span className="font-medium text-xl leading-3xl">
                    {t('public.site.pricing.datasync.unit.objects', {})}
                  </span>
                </div>
              </div>
            </div>
            <div className="text-xs font-regular leading-xs text-gray-600 w-full">
              <p className="mb-m">
                {t('public.site.pricing.datasync.desc', {})}
              </p>
              <div className="mb-m pl-3xs">
                <div className="flex gap-2xs mb-0">
                  <span>•</span>
                  <span>{t('public.site.pricing.datasync.example1', {})}</span>
                </div>
                <div className="flex gap-2xs mb-0">
                  <span>•</span>
                  <span>{t('public.site.pricing.datasync.example2', {})}</span>
                </div>
                <div className="flex gap-2xs">
                  <span>•</span>
                  <span>{t('public.site.pricing.datasync.example3', {})}</span>
                </div>
              </div>
              <p>
                {t('public.site.pricing.datasync.gb.note', {})}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
